import { RequestResponse } from "../../constants/requestResponse";
import { Request } from "../../constants/request";
import { MICROSERVICIOS } from "../../constants/constants";

export default class Planitrack {
     static async getDatos(solicitud:string, key:number): Promise<RequestResponse> {
       
        return new Request(MICROSERVICIOS.PLANITRAK).getPlanitrak2(solicitud, key);
    }
}